import React from 'react';

import {useAccountSettingsState} from 'app/settings/api';
import {
  useSwitch,
  useToggleWidgetIsOpen,
  useWidgetIsOpenState,
} from 'app/settings/hooks';

import {ChatWidget} from './ChatWidget';

const chatWidgetName = 'dashboard-chat-widget';

export function DashboardChatWidget() {
  const {account_id, account_email, require_ai_data_sharing_at} =
    useAccountSettingsState().data!;
  const toggleWidgetIsOpen = useToggleWidgetIsOpen();
  const isShowingChat = useWidgetIsOpenState({
    contentType: 'accountprofile',
    objectId: account_id,
    widgetName: chatWidgetName,
  });

  const rag = useSwitch('ragaccount');
  return (
    <>
      {rag && require_ai_data_sharing_at ? (
        <ChatWidget
          isHidingChat={!isShowingChat}
          toggleChat={() =>
            toggleWidgetIsOpen({
              contentType: 'accountprofile',
              objectId: account_id,
              widgetName: chatWidgetName,
            })
          }
          url={account_email}
          objectId={account_id}
          contentType={'accountprofile'}
          chatType={'ragaccount'}
        />
      ) : null}
    </>
  );
}
